import Vue from 'vue'
import Vuex from 'vuex'
import * as user from '@/store/modules/user.js'
import * as patient from '@/store/modules/patient.js'
import * as locale from '@/store/modules/locale.js'
import * as customization from '@/store/modules/customization.js'
import * as filter from '@/store/modules/filter.js'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    patient,
    locale,
    customization,
    filter
  }
})
